(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-items"] && !Shopify.designMode) return;
  try {
    
  $('.category-items-box h1').click(function(j) {
          var dropDown = $(this).closest('.category-items-box').find('.category-items-box-content'); 
          $(this).closest('.category-items').find('.category-items-box-content').not(dropDown).slideUp();
          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
          } else {
            $(this).closest('.category-items').find('h1.active').removeClass('active');
            $(this).addClass('active');
          }
          dropDown.stop(false, true).slideToggle();
          j.preventDefault();
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
      

$(document).ready(function () {
    function updateInnerHTMLForMobile() {
        if ($(window).width() <= 600) { 
            $(".third-sec").html(`
                <img src="https://cdn.shopify.com/s/files/1/0658/6938/1787/files/Frame_131.png " alt="Mobile Image" />
            `);
        }
    }
    updateInnerHTMLForMobile();

    $(window).resize(function () {
        updateInnerHTMLForMobile();
    });
});
  

  } catch(e) { console.error(e); }
})();
})();
